module.exports = __webpack_public_path__ + "static/ocean-robbins-veggies-crop.4afd8b57.jpg";